module.exports = __webpack_public_path__ + "img/monkija.5017415f.jpeg";